import "./header.scss";

export const Header = () => {
  return (
    <header className="flex" id="header-login">
      <div className="flex items-center font-medium">
        <img width={200} alt="admdoc logo" src="/logos/logo-solid.png" />
      </div>
    </header>
  );
};
